(function(){"use strict";
if(window.__BT01_RUNNING__)return;
window.__BT01_RUNNING__=true;

var WRAP_SEL=".BT01_wrap[data-bt01='true']";
var TIER_SEL="[data-bt01-tier]";
var QTY_SELS=["input[name='quantity']","input.quantity__input","input[data-quantity-input]",".quantity input[type='number']"];

function qs(root,sel){try{return(root||document).querySelector(sel);}catch(e){return null;}}
function qsa(root,sel){try{return Array.from((root||document).querySelectorAll(sel));}catch(e){return[];}}
function fmt(v){try{return new Intl.NumberFormat("es-ES",{style:"currency",currency:"EUR",minimumFractionDigits:2}).format(v);}catch(e){return v.toFixed(2)+" \u20ac";}}

function getProductPrice(){
  try{
    var meta=qs(document,"meta[property='og:price:amount']");
    if(meta){var v=parseFloat(meta.content);if(v>0)return v;}
  }catch(e){}
  try{
    if(window.ShopifyAnalytics&&window.ShopifyAnalytics.meta&&window.ShopifyAnalytics.meta.product){
      var p=window.ShopifyAnalytics.meta.product;
      if(p.variants&&p.variants[0]&&p.variants[0].price)return p.variants[0].price/100;
    }
  }catch(e){}
  try{
    var priceEl=qs(document,".price__current .money, .price-item--sale .money, .price-item--regular .money, [data-product-price]");
    if(priceEl){var t=priceEl.textContent.replace(/[^\d.,]/g,"").replace(",",".");var pv=parseFloat(t);if(pv>0)return pv;}
  }catch(e){}
  return 0;
}

function getComparePrice(){
  try{
    // Try all possible compare price selectors
    var sels=[".price__compare .money",".price-item--compare-at .money",".price__was .money","s .money","del .money",".price--compare",".compare-at-price","[data-compare-price]","[data-product-compare-price]",".price s","s.price-item"];
    for(var i=0;i<sels.length;i++){
      var el=qs(document,sels[i]);
      if(el){
        var t=el.textContent.replace(/[^\d.,]/g,"");
        // Handle European format: 170,41 → 170.41
        if(t.indexOf(",")>-1&&t.indexOf(".")===-1)t=t.replace(",",".");
        else if(t.indexOf(",")>t.indexOf("."))t=t.replace(".","").replace(",",".");
        var v=parseFloat(t);
        if(v>0)return v;
      }
    }
  }catch(e){}
  try{
    if(window.ShopifyAnalytics&&window.ShopifyAnalytics.meta&&window.ShopifyAnalytics.meta.product){
      var p=window.ShopifyAnalytics.meta.product;
      if(p.variants&&p.variants[0]&&p.variants[0].compare_at_price)return p.variants[0].compare_at_price/100;
    }
  }catch(e){}
  // Fallback: estimate compare as 2x price (50% off baseline)
  var price=getProductPrice();
  if(price>0)return price*2;
  return 0;
}

function findQtyInput(){
  for(var i=0;i<QTY_SELS.length;i++){var el=qs(document,QTY_SELS[i]);if(el)return el;}
  return null;
}

function setQty(n){
  var input=findQtyInput();
  if(!input)return;
  // Safari-safe: set value directly and trigger events
  input.setAttribute("value",String(n));
  input.value=String(n);
  // Try native event dispatch (Safari compatible)
  try{
    var ev=document.createEvent("HTMLEvents");
    ev.initEvent("input",true,true);
    input.dispatchEvent(ev);
  }catch(e){}
  try{
    var ev2=document.createEvent("HTMLEvents");
    ev2.initEvent("change",true,true);
    input.dispatchEvent(ev2);
  }catch(e){}
}

function updatePrices(wrap,price,compare){
  if(!price)return;
  var tiers=qsa(wrap,TIER_SEL);
  for(var i=0;i<tiers.length;i++){
    var tier=tiers[i];
    var qty=parseInt(tier.getAttribute("data-qty")||"1",10);
    var disc=parseInt(tier.getAttribute("data-discount")||"0",10);
    var unitPrice=price*(1-disc/100);
    var total=unitPrice*qty;
    var compareTotal=compare>0?compare*qty:0;

    var priceEl=qs(tier,"[data-bt01-price]");
    var cmpEl=qs(tier,"[data-bt01-cmp]");
    var unitEl=qs(tier,"[data-bt01-unit]");
    var saveEl=qs(tier,"[data-bt01-save]");
    var offEl=qs(tier,"[data-bt01-off]");

    if(priceEl){
      priceEl.textContent=fmt(total);
    }
    if(cmpEl&&compareTotal>0){
      cmpEl.textContent=fmt(compareTotal);
    }
    if(unitEl&&qty>1){
      unitEl.textContent=fmt(unitPrice)+"/ud";
    }
    if(offEl&&compareTotal>0){
      var offPct=Math.round((1-total/compareTotal)*100);
      offEl.textContent="-"+offPct+"%";
    }
    if(saveEl&&compareTotal>0&&qty>1){
      var saved=compareTotal-total;
      saveEl.textContent="Ahorras "+fmt(saved);
    }
  }
}

function selectTier(wrap,tierNum){
  var tiers=qsa(wrap,TIER_SEL);
  for(var i=0;i<tiers.length;i++){
    var t=tiers[i];
    var n=t.getAttribute("data-bt01-tier");
    var radio=qs(t,"input[type='radio']");
    if(n===String(tierNum)){
      t.classList.add("BT01_tier--active");
      if(radio)radio.checked=true;
    }else{
      t.classList.remove("BT01_tier--active");
      if(radio)radio.checked=false;
    }
  }
  setQty(tierNum);
}

function placeBelowRating(wrap){
  var scope=qs(document,".product-information, .product__info-container, [data-product-details], main");
  if(!scope)return;
  var buyBtn=qs(scope,"[data-testid='add-to-cart-button'], button[name='add'], .product-form__submit");
  if(!buyBtn)return;
  var form=buyBtn.closest("form")||buyBtn.parentElement;
  if(form&&form.parentNode){
    form.parentNode.insertBefore(wrap,form);
  }
}

function bindTiers(wrap){
  var tiers=qsa(wrap,TIER_SEL);
  for(var i=0;i<tiers.length;i++){
    (function(tier){
      var handler=function(e){
        if(e&&e.preventDefault)e.preventDefault();
        if(e&&e.stopPropagation)e.stopPropagation();
        var n=parseInt(tier.getAttribute("data-bt01-tier")||"1",10);
        selectTier(wrap,n);
      };
      tier.addEventListener("click",handler,false);
    })(tiers[i]);
  }
}

function hideQtySelector(){
  try{
    var selectors=[".quantity",".product-form__quantity",".quantity-selector","[data-quantity-selector]",".quantity__wrapper"];
    for(var i=0;i<selectors.length;i++){
      var els=qsa(document,selectors[i]);
      for(var j=0;j<els.length;j++){
        var el=els[j];
        if(el&&el.querySelector&&el.querySelector("input[name='quantity']")){
          el.style.display="none";
        }
      }
    }
    // Make add to cart button full width
    var btn=qs(document,".product-form__submit, button[name='add'], [data-testid='add-to-cart-button']");
    if(btn){
      var btnParent=btn.closest(".product-form__buttons, .buy-buttons, .shopify-payment-button__button--unbranded")||btn.parentElement;
      if(btnParent){btnParent.style.width="100%";}
      btn.style.width="100%";
    }
    // Hide the quantity + buttons row
    var buyBtns=qs(document,"buy-buttons, .buy-buttons");
    if(buyBtns){
      var qtyWrap=buyBtns.querySelector(".quantity, [data-quantity]");
      if(qtyWrap)qtyWrap.style.display="none";
    }
  }catch(e){}
}

function run(wrap,price,compare){
  updatePrices(wrap,price,compare);
  placeBelowRating(wrap);
  wrap.removeAttribute("hidden");
  bindTiers(wrap);
  selectTier(wrap,1);
  hideQtySelector();
  // Add class to parent scope for CSS-based hiding
  try{
    var scope=qs(document,".product-information, .product__info-container, [data-product-details]");
    if(scope)scope.classList.add("BT01_active");
    var form=qs(document,"form[action*='/cart/add'],.product-form");
    if(form)form.classList.add("BT01_active");
  }catch(e){}
}

function init(){
  var wrap=qs(document,WRAP_SEL);
  if(!wrap)return;
  var price=getProductPrice();
  var compare=getComparePrice();
  if(!price||price<=0){
    setTimeout(function(){
      price=getProductPrice();
      compare=getComparePrice();
      if(price>0)run(wrap,price,compare);
    },1000);
    return;
  }
  run(wrap,price,compare);
}

function safeInit(){
  try{init();}catch(e){console.warn("BT01 init error:",e);}
}
if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",safeInit,false);
}else{
  safeInit();
}
// Retry for slow iOS rendering
setTimeout(safeInit,1500);
setTimeout(safeInit,3000);
document.addEventListener("shopify:section:load",safeInit,false);
})();
